export const CONTACT_TOPICS = [
    'A general question',
    'Plans and billing',
    'Calls with an advisor',
    'Partnerships',
    'Press and media'
]

export const OFFICES = [
    {
        city: 'New York',
        address: ['120 Greene Street, 4th floor', 'New York, NY 10012'],
        hours: 'Weekdays, 9:00 to 18:00 ET',
        phone: '(212) 555-0147'
    },
    {
        city: 'San Francisco',
        address: ['455 Market Street, Suite 900', 'San Francisco, CA 94105'],
        hours: 'Weekdays, 9:00 to 18:00 PT',
        phone: '(415) 555-0182'
    },
    {
        city: 'Austin',
        address: ['801 Barton Springs Road', 'Austin, TX 78704'],
        hours: 'Weekdays, 9:00 to 17:00 CT',
        phone: '(512) 555-0126'
    }
]
